export default function getLocalDate(date) {
  if (!date) return '';
  return new Date(date)?.toLocaleString('uk-UA', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });
}
